import { adminRequester } from "App";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
function RequireAdminAuth(props) {
  const { allowedRoles, to = "/" } = props;
  const [user, setUser] = useState();
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    adminRequester.getCurrentUser(({ user }) => {
      setUser(user);
      setLoading(false);
    });
  }, []);

  if (!isLoading) {
    if (user) {
      if (allowedRoles.includes(user?.role)) {
        return <Outlet />;
      } else {
        return <Navigate replace to={to} />;
      }
    } else {
      return <Navigate replace to={to} />;
    }
  } else {
    return <></>;
  }
}

export default RequireAdminAuth;
